var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7128 3H7.60408C5.63164 3 4 4.62422 4 6.59785V31.4021C4 33.3758 5.63164 35 7.60408 35H25.3963C27.3688 35 29 33.3758 29 31.4021V11.6984L20.7128 3Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.841 3.14648L29.159 11.8534L23.8369 12.0446C22.3591 12.0977 21.1182 10.8619 21.0614 9.28027L20.841 3.14648Z",
    style: {
      fillOpacity: 0.5
    },
    fill: "white"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1797 29.3599H9.81187C9.36541 29.3599 9 29.7288 9 30.1798C9 30.6311 9.36541 31 9.81187 31H23.1879C23.6346 31 24 30.6311 24 30.1798C24 29.7288 23.6346 29.3599 23.1797 29.3599Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3379 20.536L15.6838 16.9033V25.858C15.6838 26.3092 16.0492 26.6782 16.4959 26.6782C16.9426 26.6782 17.3082 26.3092 17.3082 25.858V16.9029L20.6541 20.536C20.8164 20.708 21.0275 20.7983 21.2468 20.7983C21.4419 20.7983 21.6447 20.7245 21.7993 20.5768C22.1239 20.2653 22.1483 19.7486 21.8398 19.4206L17.0888 14.2623C16.9345 14.0984 16.7234 14 16.4961 14C16.2686 14 16.0574 14.0984 15.9032 14.2623L11.1522 19.4206C10.8437 19.7486 10.8681 20.2735 11.1927 20.5768C11.5176 20.8884 12.0291 20.8638 12.3379 20.536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0.859253,
    width: 33.159,
    height: 40.1407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.205966 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.974742aa.svg";
export { ForwardRef as ReactComponent };